// DOMAIN URL
import { getCountry, getWithDotComByCountry } from '../utils';

export const COUNTRY: supportedCountries = getCountry().toLowerCase();
const withCom = getWithDotComByCountry(COUNTRY);

const dicEnvironments = [
  {environment: 'prod', domain: `neogig${withCom}${COUNTRY}`, 'imageDomain': `https://image.neogig${withCom}${COUNTRY}`},
  {environment: 'refactory', domain: `refactory.neogig${withCom}${COUNTRY}`, 'imageDomain': `https://image.neogig${withCom}${COUNTRY}`},
  {environment: 'qa', domain: `qa.neogig${withCom}${COUNTRY}`, 'imageDomain': `https://image.neogig${withCom}${COUNTRY}`},
  {environment: 'dev', domain: `dv.neogig${withCom}${COUNTRY}`, 'imageDomain': `https://image.neogig${withCom}${COUNTRY}`},
  {environment: 'local', domain: `localhost`, 'imageDomain': `https://image.neogig${withCom}${COUNTRY}`},
];

const { environment, imageDomain } = dicEnvironments.find(x => location.hostname.toLowerCase() === x.domain) || dicEnvironments[0];

const { env } = require(`./${environment}.env`);

export const CONFIG = {
  ...env ,
  IMAGES_HOST: `/static/images`,
  STORE_IMAGES_HOST: `${imageDomain}/imagemloja/automoveis`,
  STORE_THUMBS_HOST: `${imageDomain}/imagemloja_thumbs/automoveis`,
  NAME: 'NeoGIG',
  VERSION: '2.23.1',
  COMPANY: 'Neocom'
};



// WEBPACK FOOTER //
// ./src/config/index.js